module.exports = __webpack_public_path__ + "static/media/premium_user_banner.fe0e2d8a.png";